import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import ExamSidebar from './ExamSidebar';
import ExamHeader from './ExamHeader';

function ExamFooter() {
  return (
    <footer style={{
      borderTop: '1px solid var(--exam-border)',
      padding: '10px 24px',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      flexWrap: 'wrap',
      gap: 8,
      fontSize: 11,
      color: 'var(--exam-text-muted)',
      background: 'var(--exam-surface)',
    }}>
      <span>© {new Date().getFullYear()} ExaminationOS · AI drafts content — Faculty reviews, edits, and approves.</span>
      <div style={{ display: 'flex', gap: 16 }}>
        {[
          { label: 'Terms of Use',        href: '/terms' },
          { label: 'Privacy Policy',      href: '/privacy' },
          { label: 'AI Ethics Policy',    href: '/ai-ethics-policy' },
        ].map(({ label, href }) => (
          <a key={href} href={href} style={{ color: 'var(--exam-text-muted)', textDecoration: 'none' }}
            target="_blank" rel="noreferrer">
            {label}
          </a>
        ))}
      </div>
    </footer>
  );
}

export default function ExamPageShell({ breadcrumbs, headerActions, children }) {
  const [collapsed, setCollapsed] = useState(false);
  const { user } = useSelector((s) => s.user || {});

  return (
    <div className="exam-app">
      <div className="exam-shell">
        <ExamSidebar
          collapsed={collapsed}
          onToggle={() => setCollapsed((c) => !c)}
          user={user}
        />
        <div className={`exam-main${collapsed ? ' sidebar-collapsed' : ''}`}>
          <ExamHeader breadcrumbs={breadcrumbs || []} actions={headerActions} />
          <main className="exam-page">
            {children}
          </main>
          <ExamFooter />
        </div>
      </div>
    </div>
  );
}
